import { useMemo, useState } from "react";
import { MRT_ColumnDef } from "material-react-table";
import { formatDate, formatPhone } from "../helpers/format";
import VirtualizedTable from "./VirtualizeTable";
import { useNavigate } from "react-router";
import { Button } from "@mui/material";
import StudentRegister from "./StudentRegister";

type Student = {
  id: number;
  unique_token: string;
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  createdAt: string;
  studentId?: string;
};

const StudentTable = ({ data, refetch }: { data: Student[]; refetch: any }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState<any>({ open: false, gympassStudent: null });

  const columns = useMemo<MRT_ColumnDef<Student>[]>(
    () => [
      {
        id: "fullName",
        header: "Nome completo",
        Cell: ({ row }) =>
          `${row.original.first_name ?? ""} ${row.original.last_name ?? ""}`,
      },
      { accessorKey: "email", header: "E-mail" },
      {
        accessorKey: "phone_number",
        header: "Telefone",
        Cell: ({ cell }) => formatPhone(cell.getValue<string>()),
      },
      {
        accessorKey: "createdAt",
        header: "Criado em",
        Cell: ({ cell }) => formatDate(cell.getValue<string>()),
      },

      {
        id: "detalhes",
        header: "Ações",
        Cell: ({ row }) =>
          row?.original?.studentId ? (
            <Button
              variant="contained"
              color="success"
              fullWidth
              onClick={() => {
                navigate("/students-details/" + row?.original?.studentId);
              }}
            >
              Ver detalhes
            </Button>
          ) : (
            <Button
              variant="contained"
              color="warning"
              fullWidth
              onClick={() => {
                setOpen({ open: true, gympassStudent: row?.original });
              }}
            >
              Cadastrar aluno
            </Button>
          ),
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },
      },
    ],
    []
  );

  return (
    <>
      <VirtualizedTable
        data={data}
        columns={columns}
        fetchNextPage={() => Promise.resolve()}
        isLoading={false}
      />
      {open.open && (
        <StudentRegister
          open={open.open}
          gympassStudent={open.gympassStudent}
          onClose={() => setOpen({ open: false, gympassStudent: null })}
          refetch={refetch}
        />
      )}
    </>
  );
};

export default StudentTable;
